var React = require('react');

function Close (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M6.21615 6.21615C6.50435 5.92795 6.97162 5.92795 7.25982 6.21615L12.9991 11.9555L18.7402 6.21615C18.9964 5.95997 19.394 5.93151 19.6816 6.13076L19.7838 6.21615C20.0721 6.50435 20.0721 6.97162 19.7838 7.25982L14.0426 12.9991L19.7838 18.7402C20.04 18.9964 20.0685 19.394 19.8692 19.6816L19.7838 19.7838C19.4956 20.0721 19.0284 20.0721 18.7402 19.7838L12.9991 14.0426L7.25982 19.7838C7.00364 20.04 6.60598 20.0685 6.31836 19.8692L6.21615 19.7838C5.92795 19.4956 5.92795 19.0284 6.21615 18.7402L11.9555 12.9991L6.21615 7.25982C5.95997 7.00364 5.93151 6.60598 6.13076 6.31836L6.21615 6.21615Z","fill":"currentColor"}));
}

Close.defaultProps = {"width":"100%","height":"100%","viewBox":"0 0 26 26","fill":"none"};

module.exports = Close;

Close.default = Close;
